export const ISSUE_API_ROOT = '/issues-tracking/v1/issues';
// Sibling permissions/config route at the same version root as the issues root.
export const ISSUE_PERMISSIONS_API_ROOT = ISSUE_API_ROOT.replace(
  /\/issues$/,
  '/permissions/config',
);
export const ISSUE_ENTITY_NAME = 'ISSUE';
export const SXCL_SERVICES_API_ROOT = '/sxcl/v1';

export const ISSUES_LIST_STORE_NAME = 'IssuesList';

export const ISSUE_LOOKUP_CATEGORIES = [
  'STATUS',
  'PRIORITY',
  'TYPE',
  'COMPONENT',
  'RESOLUTION_CODE',
];

export const INITIAL_LOOKUPS = {
  STATUS: [],
  PRIORITY: [],
  TYPE: [],
  COMPONENT: [],
  RESOLUTION_CODE: [],
};

export const INITIAL_ISSUE_FORM = {
  title: '',
  description: '',
  typeCode: 'BUG',
  priorityCode: 'MEDIUM',
  componentCode: 'OTHER',
  companyId: '',
  serviceAdministratorId: '',
};

export const END_STATE_STATUS_CODES = [
  'RESOLVED',
  'CLOSED',
  'CANCELLED',
  'DUPLICATE',
];

// Statuses that exist in the backend lookup data but are not part of the
// supported request workflow; never offered as quick filters (SXCL-2475).
// The search Status dropdown excludes them too (see schemas/search.json).
export const UNSUPPORTED_STATUS_CODES = ['BLOCKED', 'CLOSED', 'DUPLICATE'];

export const STATUS_COLOR = {
  BACKLOG: 'default',
  OPEN: 'info',
  NEEDS_INFO: 'warning',
  WAITING_FOR_REPORTER: 'warning',
  IN_PROGRESS: 'primary',
  BLOCKED: 'error',
  ON_HOLD: 'default',
  READY_FOR_REVIEW: 'info',
  IN_REVIEW: 'info',
  RESOLVED: 'success',
  CLOSED: 'default',
  DUPLICATE: 'default',
  CANCELLED: 'error',
};

export const PRIORITY_COLOR = {
  CRITICAL: 'error',
  HIGH: 'warning',
  MEDIUM: 'info',
  LOW: 'default',
};
